import React, { Component } from 'react';

class TextInput extends Component {

	constructor(props) {
		super(props);
		this.state = {'text': 'Phrase Here'};
	}

  copyText = () => {
    this.refs.input.select();
    document.execCommand('copy');
  }

  render() {

    const Input = React.createElement("input", {
      ref: 'input',
      type: 'text',
      readOnly: this.props.readonly,
      disabled: this.props.disabled,
      value: this.props.value,
      onChange: this.props.onChange,
    });

    return (
    <div className="control-wrap text-input">
      <span className="control-label">{this.props.name}
          {this.props.canCopy && <span className="copy" display={this.props.canCopy} onClick={this.copyText}>&nbsp;> Copy</span> }
      </span> 
      {Input}
    </div>
    )
  }
	
}

export default TextInput;


// WEBPACK FOOTER //
// ./src/controls/TextInput.jsx